// Utils
import http from 'utils/http';

export const requestVerificationTypes = async body => {
  try {
    const response = await http.post('/verification/digilocker', body);
    return response;
  } catch (error) {
    return {
      error,
    };
  }
};

export const getDigilockerDetails = async id => {
  try {
    const response = await http.get(
      `verification/digilocker?verification_id=${id}`,
    );

    return response;
  } catch (error) {
    return {
      error,
    };
  }
};

export const getDocDetails = async (docs, id) => {
  try {
    const response = await http.get(
      `verification/digilocker/document/${docs}?verification_id=${id}`,
    );

    return response;
  } catch (error) {
    return {
      error,
    };
  }
};
